import { graphql } from 'react-relay';

export type { error403RootQuery as error403RootQueryType } from './__generated__/error403RootQuery.graphql';

export const error403RootQuery = graphql`
    query error403RootQuery($showModules: Boolean = true) {
        viewer {
            ...Error403Layout_viewer
        }
    }
`;
